var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoDimensionalCodeOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21338 7.38818C6.21338 6.42169 6.99688 5.63818 7.96338 5.63818H21.9634C22.9299 5.63818 23.7134 6.42169 23.7134 7.38818V21.3882C23.7134 22.3547 22.9299 23.1382 21.9634 23.1382H7.96338C6.99688 23.1382 6.21338 22.3547 6.21338 21.3882V7.38818ZM9.71338 9.13818V19.6382H20.2134V9.13818H9.71338Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21338 35.3882C6.21338 34.4217 6.99688 33.6382 7.96338 33.6382H21.9634C22.9299 33.6382 23.7134 34.4217 23.7134 35.3882V49.3882C23.7134 50.3547 22.9299 51.1382 21.9634 51.1382H7.96338C6.99688 51.1382 6.21338 50.3547 6.21338 49.3882V35.3882ZM9.71338 37.1382V47.6382H20.2134V37.1382H9.71338Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2134 35.3882C34.2134 34.4217 34.9969 33.6382 35.9634 33.6382H49.9634C50.9299 33.6382 51.7134 34.4217 51.7134 35.3882V49.3882C51.7134 50.3547 50.9299 51.1382 49.9634 51.1382H35.9634C34.9969 51.1382 34.2134 50.3547 34.2134 49.3882V35.3882ZM37.7134 37.1382V47.6382H48.2134V37.1382H37.7134Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2134 7.38818C34.2134 6.42169 34.9969 5.63818 35.9634 5.63818H49.9634C50.9299 5.63818 51.7134 6.42169 51.7134 7.38818V21.3882C51.7134 22.3547 50.9299 23.1382 49.9634 23.1382H35.9634C34.9969 23.1382 34.2134 22.3547 34.2134 21.3882V7.38818ZM37.7134 9.13818V19.6382H48.2134V9.13818H37.7134Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9634 5.63818C29.9299 5.63818 30.7134 6.42169 30.7134 7.38818V28.3882C30.7134 29.3547 29.9299 30.1382 28.9634 30.1382C27.9969 30.1382 27.2134 29.3547 27.2134 28.3882V7.38818C27.2134 6.42169 27.9969 5.63818 28.9634 5.63818Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9634 33.6382C29.9299 33.6382 30.7134 34.4217 30.7134 35.3882V49.3882C30.7134 50.3547 29.9299 51.1382 28.9634 51.1382C27.9969 51.1382 27.2134 50.3547 27.2134 49.3882V35.3882C27.2134 34.4217 27.9969 33.6382 28.9634 33.6382Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21338 28.3882C6.21338 27.4217 6.99688 26.6382 7.96338 26.6382H28.9634C29.9299 26.6382 30.7134 27.4217 30.7134 28.3882C30.7134 29.3547 29.9299 30.1382 28.9634 30.1382H7.96338C6.99688 30.1382 6.21338 29.3547 6.21338 28.3882Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2134 28.3882C34.2134 27.4217 34.9969 26.6382 35.9634 26.6382H49.9634C50.9299 26.6382 51.7134 27.4217 51.7134 28.3882C51.7134 29.3547 50.9299 30.1382 49.9634 30.1382H35.9634C34.9969 30.1382 34.2134 29.3547 34.2134 28.3882Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoDimensionalCodeOne);
export default __webpack_public_path__ + "static/media/two-dimensional-code-one.860e2435.svg";
export { ForwardRef as ReactComponent };